/* eslint-disable */

import { Image } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import placeholderImg from '../../../assets/images/placeholder.webp';
import CardProductPreviewMask from './CardProductPreviewMask';
import './CardProduct.css';

const productImagePreviewMask = <CardProductPreviewMask />;

function CardProduct({ shopitem, show_shop, disableLink }) {
  if (!shopitem) return null;

  const cardContent = (
    <div
      className='ant-card ant-card-bordered u-unfold--css-animation fadeInRight h-100'
      style={{
        animationDuration: '800ms',
        left: '0px',
        cursor: disableLink ? 'default' : undefined,
      }}
    >
      <div className='bg-image'>
        <Image
          src={
            shopitem?.productitem_id && shopitem?.img1_key
              ? `${process.env.REACT_APP_IMAGE_URL}${shopitem.productitem_id}/${shopitem.productitem_id}-1-${shopitem.img1_key}.jpg`
              : placeholderImg
          }
          fallback={placeholderImg}
          alt='Meya Shop Items Image'
          loading='lazy'
          preview={{ mask: productImagePreviewMask }}
        />
      </div>

      <div className='card-body'>
        <h5 className='ant-card-title truncate-2'>
          {shopitem.productitem_name}
        </h5>
        <p className='ant-card-text truncate-1'>
          {shopitem.productitem_inter}
        </p>

        <div className='price-container'>
          <div className='unit-label'>
            ราคาต่อ {shopitem.first_priceunit} ชิ้น
          </div>
          <div className='d-flex align-items-baseline'>
            {shopitem.first_pricenew > 0 ? (
              <>
                <span className='price-main'>
                  ฿ {Number(shopitem.first_pricenew).toLocaleString()}
                </span>
                <span className='price-original'>
                  ฿ {Number(shopitem.first_pricebase).toLocaleString()}
                </span>
              </>
            ) : (
              <span className='price-main'>
                ฿ {Number(shopitem.first_pricebase).toLocaleString()}
              </span>
            )}
          </div>

          {show_shop === true && (
            <div className='shop-metadata'>
              <div className='shop-name-label truncate-1'>
                <i className='fe-shopping-bag'></i> {shopitem.shop_name}
              </div>
              <div className='province-label'>
                <i className='fe-map-pin'></i> {shopitem.shop_province}
              </div>
            </div>
          )}
        </div>
      </div>

      {shopitem.first_pricenew > 0 ? (
        <div className='ribbon-wrapper'>
          <div className='ribbon-tag discount'>ลดราคา</div>
        </div>
      ) : shopitem.ads === true ? (
        <div className='ribbon-wrapper'>
          <div className='ribbon-tag recommended'>แนะนำ</div>
        </div>
      ) : null}
    </div>
  );

  return (
    <div className='flex-box '>
      {disableLink ? (
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => {
            alert('ผู้หางานระบบสายสุขภาพไม่สามารถเข้าดูรายละเอียดสินค้าหรือทำการซื้อขายได้');
          }}
        >
          {cardContent}
        </div>
      ) : (
        <Link
          to={
            '/marketplace/productview?shopitem=' +
            `${shopitem.shopitem_id}` +
            '&productitem=' +
            `${shopitem.productitem_id}`
          }
        >
          {cardContent}
        </Link>
      )}
    </div>
  );
}

export default CardProduct;
